/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {ContractRowSkeletonMobile} from "./ContractRowSkeletonMobile";
import {ContractRowHeaderSkeleton} from "./ContractRowHeaderSkeleton";
import {ContractRowSkeleton} from "./ContractRowSkeleton";

export const ContractSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <ContractRowSkeletonMobile key={i}/>)}</>
        :
        <><ContractRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <ContractRowSkeleton key={i}/>)}</>
}

